<div class="step-title">What to create?</div>

<div class="create-type-list">
  <div class="create-type-option" *ngFor="let option of options"
       [class.disabled]="!option.enabled"
       [class.selected]="selectedType === option.type"
       [title]="option.enabled ? '' : 'Coming soon'"
       (click)="select(option)">
    <input type="radio" name="wizardCreateType"
           [checked]="selectedType === option.type"
           [disabled]="!option.enabled" />
    <i class="fas" [ngClass]="option.icon"></i>
    <span class="create-type-text"><strong>{{ option.leadLabel }}</strong> {{ option.restLabel }}</span>
  </div>
</div>
